import React from "react";
import { NavLink, Outlet } from "react-router-dom";

import { SETTINGS_TABS } from "../../tabs";
import "./SettingsView.scss";

export function SettingsView() {
  return (
    <div className="settings-component">
      <div className="header">
        <h1>Settings</h1>
      </div>

      <div className="settings-body">
        <nav className="settings-rail" aria-label="Settings sections">
          {SETTINGS_TABS.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `rail-item ${isActive ? "active" : ""}`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>

        <div className="settings-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
